import React, { useMemo } from 'react';
import { mockLoans } from '../data/mockConditions';
import { LoanCard } from '../components/conditions/LoanCard';
import { FileText, MessageSquare, CheckCircle2, AlertCircle } from 'lucide-react';
export function ConditionsReview() {
  // Summary stats — only count active conditions that have something to review
  const stats = useMemo(() => {
    let conditions = 0;
    let documents = 0;
    let comments = 0;
    mockLoans.forEach(loan => {
      loan.conditions.forEach(condition => {
        if (condition.status !== 'Review') return;
        const unreadCount = condition.comments.filter(cm => cm.isRead === false).length;
        if (condition.documents.length === 0 && unreadCount === 0) return;
        conditions++;
        documents += condition.documents.filter(d => d.status === 'Pending').length;
        comments += unreadCount;
      });
    });
    return {
      conditions,
      documents,
      comments
    };
  }, []);
  // Loans with at least one displayable condition
  const visibleLoans = useMemo(() => {
    return mockLoans.filter(loan => loan.conditions.some(c => c.status === 'Review' && (c.documents.length > 0 || c.comments.some(cm => cm.isRead === false))));
  }, []);
  return <div className="min-h-screen bg-slate-100 text-slate-900 font-sans" data-id="element-241">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-10 shadow-sm" data-id="element-242">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-243">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-244">
            <div data-id="element-245">
              <h1 className="text-2xl font-bold text-slate-900" data-id="element-246">
                Conditions Review
              </h1>
              <p className="text-sm text-slate-500 mt-1" data-id="element-247">
                Triage and review open items across your pipeline.
              </p>
            </div>

            {/* Summary Stats */}
            <div className="flex items-center space-x-4 bg-slate-50 p-2 rounded-lg border border-slate-200" data-id="element-248">
              <div className="flex items-center px-3 py-1 border-r border-slate-200 last:border-0" data-id="element-249">
                <AlertCircle className="w-4 h-4 text-amber-500 mr-2" data-id="element-250" />
                <span className="text-sm font-medium" data-id="element-251">
                  {stats.conditions}{' '}
                  <span className="text-slate-500 font-normal" data-id="element-252">Conditions</span>
                </span>
              </div>
              <div className="flex items-center px-3 py-1 border-r border-slate-200 last:border-0" data-id="element-253">
                <FileText className="w-4 h-4 text-blue-500 mr-2" data-id="element-254" />
                <span className="text-sm font-medium" data-id="element-255">
                  {stats.documents}{' '}
                  <span className="text-slate-500 font-normal" data-id="element-256">Docs</span>
                </span>
              </div>
              <div className="flex items-center px-3 py-1" data-id="element-257">
                <MessageSquare className="w-4 h-4 text-purple-500 mr-2" data-id="element-258" />
                <span className="text-sm font-medium" data-id="element-259">
                  {stats.comments}{' '}
                  <span className="text-slate-500 font-normal" data-id="element-260">Comments</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-261">
        <div className="space-y-6" data-id="element-262">
          {visibleLoans.length > 0 ? visibleLoans.map(loan => <LoanCard key={loan.id} loan={loan} data-id="element-263" />) : <div className="text-center py-16 bg-white rounded-xl border border-slate-200 border-dashed" data-id="element-264">
              <CheckCircle2 className="mx-auto h-12 w-12 text-slate-300" data-id="element-265" />
              <h3 className="mt-4 text-lg font-medium text-slate-900" data-id="element-266">
                Nothing to review
              </h3>
              <p className="mt-1 text-sm text-slate-500" data-id="element-267">
                You're all caught up. New conditions will appear here when
                borrowers respond.
              </p>
            </div>}
        </div>
      </main>
    </div>;
}